// extracted by mini-css-extract-plugin
export default {"listItem":"topicList-module__listItem___BBH4W","active":"topicList-module__active___kA1gg"};